import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Pie } from "react-chartjs-2";
import "./Signups.css";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend);

const Signups = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setData({
        totalSignups: 3842,
        todaySignups: 47,
        weeklySignups: 324,
        monthlySignups: 1205,
      });
      setLoading(false);
    }, 500);
  }, []);

  if (loading) {
    return (
      <div className="signups">
        <h1>Signups Analytics</h1>
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading signup data...</p>
        </div>
      </div>
    );
  }

  const signupTrendData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [{
      label: "Signups",
      data: [42, 56, 48, 72, 65, 58, 47],
      borderColor: "#9c27b0",
      backgroundColor: "rgba(156, 39, 176, 0.1)",
      tension: 0.4,
    }],
  };

  const sourceData = {
    labels: ["Facebook", "Google", "Direct", "Referral"],
    datasets: [{
      data: [45, 30, 15, 10],
      backgroundColor: ["#1877f2", "#ea4335", "#4caf50", "#ff9800"],
    }],
  };

  return (
    <div className="signups">
      <div className="analytics-header">
        <h1>Signup Analytics</h1>
      </div>

      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon total">
            <span className="material-icons">group_add</span>
          </div>
          <div className="card-content">
            <h3>Total Signups</h3>
            <p className="metric-value">{data.totalSignups.toLocaleString()}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon today">
            <span className="material-icons">today</span>
          </div>
          <div className="card-content">
            <h3>Today</h3>
            <p className="metric-value">{data.todaySignups}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon week">
            <span className="material-icons">date_range</span>
          </div>
          <div className="card-content">
            <h3>This Week</h3>
            <p className="metric-value">{data.weeklySignups}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon month">
            <span className="material-icons">calendar_month</span>
          </div>
          <div className="card-content">
            <h3>This Month</h3>
            <p className="metric-value">{data.monthlySignups}</p>
          </div>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <h3>Daily Signup Trend</h3>
          <div className="chart-container">
            <Line data={signupTrendData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>

        <div className="chart-card">
          <h3>Signup Sources</h3>
          <div className="chart-container pie-chart">
            <Pie data={sourceData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signups;
